import {Component, EventEmitter, HostListener, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {BnNgIdleService} from 'bn-ng-idle';

import * as deMessages from "assets/i18n/devextreme/es.json";
import {locale, loadMessages} from "devextreme/localization";

import {AppService} from '@api';

import {SistemaService} from '@servicios/Sistema.Service';
import {UsuarioService} from '@servicios/Usuario.service';

import {AlertaEnum, DialogoEnum, TipoOpcionEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {MensajeService} from '@mensaje/Mensaje.Service';
import {MensajeComponent} from '@mensaje/Mensaje.component';
import {DialogoOpcion} from '@mensaje/Modelo/Dialogo.model';

@Component({
    selector: 'app',
    encapsulation: ViewEncapsulation.None,
    template: `<router-outlet></router-outlet> <mensaje #mensaje></mensaje>  <ngx-loading-bar></ngx-loading-bar>`
})

export class App {
    @ViewChild('mensaje') mensajeComponent!: MensajeComponent;

    @Output() onResize: EventEmitter<any> = new EventEmitter<any>();

    @HostListener('window:mousemove') userMouseMove() {
        clearTimeout(this.userActivity);
        this.SetTimeout();
    }

    @HostListener('document:tap') userTap() {
        clearTimeout(this.userActivity);
        this.SetTimeout();
    }

    @HostListener('document:click') userClick() {
        clearTimeout(this.userActivity);
        this.SetTimeout();
    }

    @HostListener('document:mousewheel') userScroll() {
        clearTimeout(this.userActivity);
        this.SetTimeout();
    }

    @HostListener('document:keydown') userKey() {
        clearTimeout(this.userActivity);
        this.SetTimeout();
    }

    @HostListener('window:resize', ['$event'])
    private onListenerResize(event: any): void
    {
      this.onResize.emit(event);
    }

    userActivity: any;
    alertatimerIniciada: boolean = false;

    constructor(public appService: AppService, private sistemaService: SistemaService, private router: Router, private translate: TranslateService, private usuarioService: UsuarioService, private idleService: BnNgIdleService, private mensajeService: MensajeService) {
        router.events.subscribe(value => {
            if (value instanceof NavigationEnd) {
                this.sistemaService.ActivarOpcionMenu(value.urlAfterRedirects);
            }
        });

        this.appService.iniciarConteoInactividad.subscribe((valor) => {
            if (valor) {
                this.SetTimeout();
            }
        });

        this.appService.sesionFinalizada.subscribe((valor) => {
            if (valor) {
                this.MostrarReanudarSesion();
            }
        });

        loadMessages(deMessages);
        locale(navigator.language);
    }

    ngOnInit() {
    }

    SetTimeout() {
        if (localStorage.getItem(this.sistemaService.localStoreVariable.JWT) && this.sistemaService.usuario?.tiempoinactividad) {
            if (this.alertatimerIniciada) {
                this.mensajeComponent.CerrarAlertaTimer();
                this.alertatimerIniciada = false;
            }

            this.userActivity = setTimeout(() => {
                this.alertatimerIniciada = true;
                this.mensajeService.AlertaTimer(AlertaEnum.Warning, this.translate.instant("TiempoInactividadAlerta"), 60).then((terminado: boolean) => {
                    if (terminado) {
                        this.mensajeService.Alerta(AlertaEnum.Warning, this.translate.instant("TiempoInactividad"), false);
                        this.usuarioService.CerrarSesion();
                        this.mensajeComponent.CerrarDialogo();
                    }
                });

            }, this.sistemaService.usuario.tiempoinactividad);
        }
    }

    MostrarReanudarSesion() {
        if (localStorage.getItem(this.sistemaService.localStoreVariable.JWT)) {
            let opciones = [];

            opciones.push(new DialogoOpcion({Titulo: this.translate.instant("SesionFinalizado.Si"), Valor: 1}));
            opciones.push(new DialogoOpcion({Titulo: this.translate.instant("SesionFinalizado.No"), Valor: 2, Tipo: TipoOpcionEnum.negativo}));

            this.mensajeService.Dialogo(DialogoEnum.aviso, "", this.translate.instant("SesionFinalizado.Mensaje"), opciones).then((respuesta: any) => {
                if (respuesta == 1) {
                    this.usuarioService.ReanudarSesion();
                }
                else if (respuesta == 2) {
                    this.usuarioService.CerrarSesion();
                }
            });
        }
    }
}
